import { render, staticRenderFns } from "./LinkedCompSlider.vue?vue&type=template&id=3322b785&scoped=true&"
import script from "./LinkedCompSlider.vue?vue&type=script&lang=js&"
export * from "./LinkedCompSlider.vue?vue&type=script&lang=js&"
import style0 from "./LinkedCompSlider.vue?vue&type=style&index=0&id=3322b785&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3322b785",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkedCompSliderItem: require('/home/bitrix/frontend/components/compilations/LinkedCompSliderItem.vue').default})
